import React from "react";
import "./statusTag.scss";
type buttonProps = {
  className?: any;
  name?: any;
};

type buttonState = {

};
class StatusTag extends React.Component<buttonProps, buttonState> {

  constructor(props: any) {
    super(props);
    this.state = {

    };
  }

  render() {
    return (
      <>
        <span className={this.props.className}>{this.props.name}</span>
      </>
    );
  }

}

export {
  StatusTag
};

